import { configureStore } from '@reduxjs/toolkit';
import authReducer from './../slices/authSlice/authSlice';
import dropDownsReducer from './../slices/rolesAndDepartmentSlice/roleAndDepSlice';
import employeeReducer from './../slices/emloyeeSlice/employeeSlice';
import permissions from './../slices/permissionsSlice/permissionSlice';
import roleReduer from './../slices/roleSlice/roleSlice';
import attendanceReducer from './../slices/attendanceSlice/attendanceSlice';
import leavesReducer from './../slices/leaveSlice/slice';
import devicesReducer from './../slices/deviceSlice/deviceSlice';
import publicHolidays from './../slices/holidaySlice/holidaySlice';
import dashboardReducer from './../slices/dashboardSlice/dashboardSlice';
import settingReducer from './../slices/settingSlice/settingSlice';
import activityLogsReducer from './../slices/activityLogsSlice/activityLogsSlice';
import systemLogsReducer from './../slices/systemLogsSlice/systemLogsSlice';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		dropDown: dropDownsReducer,
		employee: employeeReducer,
		permissions: permissions,
		role: roleReduer,
		attendance: attendanceReducer,
		leaves: leavesReducer,
		device: devicesReducer,
		holidays: publicHolidays,
		dashboard: dashboardReducer,
		setting: settingReducer,
		activityLogs: activityLogsReducer,
		systemLogs: systemLogsReducer,
	},
});
